import { useState } from "react";
import { Carousel } from "react-bootstrap";
import { Verification } from "models/Verification";
import SlideShowItem from "./SlideShowItem";
import styles from "./slideShow.module.scss";

type Props = {
  verifications: Verification[];
  initialSlideIndex: number;
  onSlideChange: (newSlide: number) => void;
};

const SlideShow: React.FC<Props> = ({ verifications, initialSlideIndex, onSlideChange }) => {
  const [currentSlide, setCurrentSlide] = useState<number>(initialSlideIndex);

  const setSlideIndex = (selectedIndex: number) => {
    setCurrentSlide(selectedIndex);
    onSlideChange(selectedIndex); // Update currentSlide in parent component SlideShowModal
  };

  return (
    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center">
      <div className="slideshow">
        <Carousel
          variant="dark"
          activeIndex={currentSlide}
          onSelect={setSlideIndex}
          interval={null}
        >
          {verifications.map((v, index) => (
            <Carousel.Item key={v.id} className={styles.carouselItem}>
              <SlideShowItem verificationId={v.id} active={index === currentSlide} />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default SlideShow;
